<template>
  <div class="recharge">
    <div class="pageCarServeShadow cardTab">
      <p class="tabNav" :class="{ active: true }">批量绑定实体卡</p>
    </div>
    <div class="tabItem">
      <div class="form">
        <van-field
          class="pageInput phone"
          v-model="code"
          :border="false"
          type="textarea"
          rows="18"
          autosize
          maxlength="1700"
          placeholder="请输入实体卡密码，一行一卡密"
          id="carpwd"
          oninput="value=value.replace(/[^\d\n]/g,'')"
        />
        <div class="agreement">
          <van-checkbox
            v-model="checked"
            shape="square"
            icon-size="14px"
            label-disabled
            >已阅读并同意
            <div class="agreement-content">
              <span class="text" @click="agreementClickHandle()"
                >《用户注册协议及用户信息使用须知》</span
              >
            </div>
          </van-checkbox>
        </div>
        <KBtn
          class="pageBigBtns"
          color="var(--depYelColor)"
          :title="'绑定'"
          size="big"
          @click="handleClick"
        />
      </div>
    </div>
    <div class="scan">
      <van-button
        icon="scan"
        type="primary"
        size="large"
        style="border-radius: 5px"
        @click="scanHandle"
        >扫描条形码快速填写卡密</van-button
      >
    </div>
    <RegisterAndInfo ref="registerAndInfo"></RegisterAndInfo>
  </div>
</template>
<script>
import { batchReceive } from "api/submit";
import { wechatAuth } from "api/wechatSDK";
import RegisterAndInfo from "../agreement/user/registerAndInfo.vue";
export default {
  components: {
    RegisterAndInfo,
  },
  data() {
    return {
      code: "",
      checked: true,
    };
  },
  created() {
    wechatAuth(["scanQRCode"]);
  },
  methods: {
    scanHandle() {
      var that = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          let index = result.indexOf("http");
          if (index !== -1) {
            return;
          }
          let index_ = result.indexOf(",");
          if (index_ > -1) {
            result = result.substring(index_ + 1, result.length);
          }
          if (that.code.indexOf(result.trim()) == -1) {
            if (that.code && that.code.length > 0) {
              that.code += "\n" + result;
            } else {
              that.code += result;
            }
          } else {
            that.$dialog
              .alert({
                message: "卡密已存在",
              })
              .then(() => {});
          }
        },
      });
    },
    handleClick() {
      if (!this.code) {
        this.$error("请输入卡密");
        document.getElementById("carpwd").focus();
        return false;
      }
      if (!this.checked) {
        this.$error("请先阅读并勾选同意协议！");
        return false;
      }
      this.$loading("绑定中...");
      batchReceive(this.code).then((res) => {
        this.$clear();
        if (res.status == 200) {
          this.$successSync(res.message, () => {
            this.$push({
              path: "/coupons",
            });
          });
        } else {
          this.$error(res.message);
        }
      });
    },
    agreementClickHandle() {
      this.$refs["registerAndInfo"].show = true;
    },
  },
};
</script>

<style scoped lang="less">
@thColor: var(--depYelColor);
.recharge {
  margin: 0 20px;
  .title {
    margin-top: 20px;
    text-align: center;
    font-size: var(--titleFont);
    color: var(--hidColor);
    p {
      background: var(--bgColor);
      padding: 0 8px;
      display: inline-block;
      font-weight: var(--defaultFontWeight);
    }
    span {
      width: 100%;
      height: 1px;
      display: block;
      border-top: 1px dotted #ddd;
      margin-top: -10px;
    }
  }
  .cardTab {
    margin: 25px auto;
    width: 80%;
    padding: 0;
    .tabNav {
      display: inline-block;
      width: 100%;
      padding: 6px 0;
      text-align: center;
      color: var(--depHidColor);
      font-weight: var(--defaultFontWeight);
      font-size: var(--pFont);
      background: #fff;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    .active {
      position: relative;
      color: #fff;
      background: @thColor;
      &::after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        bottom: -10px;
        left: 45%;
        border-width: 5px;
        border-style: solid;
        border-color: @thColor transparent transparent transparent;
      }
    }
  }
}
.form {
  .pageInput {
    border-color: var(--depYelColor);
    position: relative;
  }
  ::placeholder {
    color: #999;
    font-size: 16px;
    font-weight: normal;
  }
  /deep/.van-cell {
    margin-top: 18px;
    // height: 50px;
    line-height: 31px;
    /deep/.van-field__control {
      color: var(--depYelColor);
      font-size: 16px;
    }
    /deep/.van-field__button {
      margin-top: -5px;
    }
    /deep/.van-button--small {
      padding: 0px 5px;
      height: 27px;
      border-radius: var(--defaultRadius);
      box-sizing: border-box;
      margin-top: -3px;
      display: inline-block;
    }
    /deep/.van-icon {
      right: 0;
      position: absolute;
    }
  }
  /deep/ .van-dialog {
    .van-cell {
      margin: 10px 0px 20px 0px;
      .van-field__control {
        color: initial;
        line-height: 20px !important;
        height: 50px;
      }
      .van-field__control::-webkit-input-placeholder {
        color: #333;
        font-size: 14px;
      }
    }
    /deep/ .van-hairline--top {
      margin-top: 20px;
    }
  }
  .phone {
    /deep/.van-field__control {
      font-weight: 900;
      font-size: 20px;

      text-align: center;
      line-height: initial;
    }
  }
  .pageBigBtns {
    margin-top: 20px;
  }
  .agreement {
    margin-top: 15px;
    font-size: var(--smallFont);
    /deep/.van-checkbox__label {
      line-height: normal;
      color: #999;
    }
    .agreement-content {
      display: inline;
      .text {
        font-weight: 700;
      }
    }
  }
}
.scan {
  margin-top: 20px;
}
</style>
